// extracted by mini-css-extract-plugin
export default {"primaryColor":"#fff","secondaryColor":"#f8f8f8","color-3":"#9f9f9f"};